import React, { Component } from 'react';
import '../assets/teachers.css';
import logo from '../assets/images/logo_avenuepm.png';
import {connect} from "react-redux";
import icon_twitter from "../assets/images/Twitter_Social_Icon.png";
import icon_fackbook from "../assets/images/Facebook_logo.png";

const Footer = class FooterComponent extends Component {

    render() {
        return (
            <footer>
                <div className="container">
                    <div className="col-lg-12">
                        <p>&copy;
                            {new Date().getFullYear() > 2010 && new Date().getFullYear()}{' '}
                              Designed and developed by researchers at the NC State University and Penn State
                            University.
                        </p>
                    </div>
                </div>
            </footer>
        )
    }
};

export default Footer
